import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "@phosphor-icons/react";
import { useLanguage } from "../i18n";

const KEY = "lp-cookie-consent";

export const CookieBanner = ({ onPrivacy }) => {
  const { t } = useLanguage();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) {
      const timer = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(timer);
    }
  }, []);

  const choose = (value) => {
    localStorage.setItem(KEY, value);
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
          className="fixed bottom-5 left-5 right-5 sm:right-auto sm:max-w-md z-[70]"
          data-testid="cookie-banner"
          role="dialog"
          aria-label="Cookie consent"
        >
          <div className="rounded-lg border border-white/10 bg-ink/90 backdrop-blur-xl p-5 shadow-[0_10px_50px_-10px_rgba(0,0,0,0.8)]">
            <div className="flex items-start gap-3">
              <Cookie size={22} weight="duotone" className="text-brand-cyan shrink-0 mt-0.5" />
              <p className="font-mono text-xs text-white/60 leading-relaxed" data-testid="cookie-text">
                {t.cookie.text}
              </p>
            </div>
            <div className="mt-4 flex gap-3">
              <button
                onClick={() => choose("accepted")}
                data-testid="cookie-accept-button"
                className="flex-1 rounded-full bg-brand-cyan text-ink px-5 py-2.5 font-mono text-[11px] uppercase tracking-widest font-bold hover:bg-brand-green transition-colors duration-300"
              >
                {t.cookie.accept}
              </button>
              <button
                onClick={() => choose("declined")}
                data-testid="cookie-decline-button"
                className="flex-1 rounded-full border border-white/15 px-5 py-2.5 font-mono text-[11px] uppercase tracking-widest text-white/60 hover:border-brand-cyan/50 hover:text-brand-cyan transition-colors duration-300"
              >
                {t.cookie.decline}
              </button>
            </div>
            <button
              onClick={onPrivacy}
              data-testid="cookie-policy-link"
              className="mt-3 font-mono text-[11px] text-white/40 underline underline-offset-4 hover:text-brand-cyan transition-colors duration-300"
            >
              {t.cookie.policyLink}
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
